/* app/page/all */

define(
	'app/page/all',[
		'jquery',
		'util/lazyload',
		'app/ui/video/video.load',
		'app/ui/rotator/rotator',
		'app/ui/expand-collapse/expand-collapse',
		'app/ui/social/share',
		'app/ui/map/map.load',
		'app/ui/form/form.umbraco',
		'app/ui/listing/operator',
		'app/ui/listing/search-results',
		'app/ui/listing/event',
		'app/ui/listing/story',
		'app/ui/cookie/cookie',
		'app/ui/listing/deals-filter',
		'app/ui/announcement/announcements',
		'app/ui/tabs/tabs',

		'app/ui/header/load',
		'phatfingaz',
		'pubsub',
		'throttledebounce',
		'tablescroll',
		'magnificPopup'
	],
	function ($, LazyLoad, VideoLoad, Rotator, ExpandCollapse, SocialShare, MapLoad, UmbracoForms, OperatorListing, SearchResults, EventListing, StoryListing, Cookie, DealsFilter, Announcements, Tabs) {

		'use strict';

		var $window = $(window);

		LazyLoad.init();
		VideoLoad.init();
		SocialShare.init();
		DealsFilter.init();
		Tabs.init();

		// TODO: Once there is a URL to use for loading
		// opt-in 3rd party cookie-based code, add it
		// to cookie.js and uncomment this
		// Cookie.init();

		// Publish Resize event
		var publishResizeEvent = function () {
			$.publish('/window/resize');
		};

		var publishScrollEvent = function () {
			$.publish('/window/scroll');
		};

		$('.js-hot').phatFingaz();

		// ExpandCollapse
		ExpandCollapse.init();

		// Table Scroll
		var $tables = $('.c-rte').find('table');
		if ($tables.length) {
			$tables.tableScroll();
		}

		// Maps
		var $maps = $('.js-map');
		if ($maps.length) {
			MapLoad.init($maps);
		}

		// Umbraco Forms
		// init function will load required dependencies if an umbraco form is present
		UmbracoForms.init();

		// Datepickers
		var $datepickers = $('.js-filter-datepicker');
		if ($datepickers.length) {
			require(
				[
					'moment',
					'pikaday'
				],
				function (moment, Pikaday) {
					$datepickers.each(function () {
						new Pikaday({
							field: this,
							yearRange: 10
						});
					});
				}
			);
		}

		// print with lazyload image
		var beforePrintFunc = function () {
			var $img = $(document).find('.js-lazy-auto');
			$img.each(function() {
				var src = $(this).attr("src");
				var dataSrc = $(this).data('original');
				if (src == '/content/images/placeholder/lazyload/square.gif') {
					$(this).attr("src", dataSrc);
				}
			});
		}

		var mediaQueryList = window.matchMedia('print');
		mediaQueryList.addListener(function (mql) {
			if (mql.matches) {
				beforePrintFunc();
			}
		});

		window.onbeforeprint = beforePrintFunc;
		 
		$(".js-print-btn").on("click", function () {
			beforePrintFunc();
			setTimeout(function () {
				window.print();
			},500)
		});

		// Announcements
		var $announcements = $('.js-announcements');
		if ($announcements.length) {
			Announcements.init();
		}
		
		// Operator Listing
		var $opLists = $('.js-operator-listing');
		if ($opLists.length) {
			OperatorListing.init($opLists);
		}

		// Search Results
		var $searchList = $('.js-search-results');
		if ($searchList.length) {
			SearchResults.init($searchList);
		}

		// Event Listing
		var $evListings = $('.js-event-listing');
		if ($evListings.length) {
			EventListing.init($evListings);
		}

		// Story Listing
		var $storyListing = $('.js-story-listing');
		if ($storyListing.length) {
			StoryListing.init($storyListing);
		}

		// Rotators
		var $rotators = $('.js-rotator');
		if ($rotators.length) {
			Rotator.init($rotators);
		}

		// Lightbox
		$('.js-lightbox-single').magnificPopup({
			delegate: '.js-lightbox-image',
			type: 'image'
		});

		$('.js-lightbox-gallery').each(function () {
			$(this).magnificPopup({
				delegate: '.js-lightbox-image',
				type: 'image',
				gallery: {
					enabled: true,
					navigateByImgClick: true,
					preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
				}
			});
		});

		$('.js-lightbox-video').magnificPopup({
			disableOn: 700,
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});

		var toggleSessionDisplay = function(event) {
			event.preventDefault();
			var $btn = $(this);
			var ogText = $btn.text();
			var altText = $btn.data('alt-text');

			$(event.delegateTarget).toggleClass('is-expanded');
			$btn.data('alt-text', ogText).text(altText);
		};

		$('.js-session-list').on('click', '.js-session-toggle', toggleSessionDisplay);

		$window.on('resize', $.throttle(250, publishResizeEvent));
		$window.on('scroll', publishScrollEvent);
	}
);
